import axios from 'axios';

type TSessionExpiryCallback = () => void;
type TApiRequestCallback = (message: string, status: 'success' | 'error') => void;

let sessionExpiryCallback: TSessionExpiryCallback | null = null;
let apiRequestCallback: TApiRequestCallback | null = null;

const api = axios.create({
    baseURL: import.meta.env.VITE_SERVER_URL + '/api',
    headers: {
        'Content-Type': 'application/json'
    },
});

api.interceptors.request.use(
    (config) => {
        if (!config.headers['Authorization']) {
            const token = localStorage.getItem('jwt_token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        const { config } = response
        if (config.meta?.showSnackbar) {
            apiRequestCallback && apiRequestCallback(response.data.message || `Success`, 'success')
        }
        return response
    },
    async (error) => {
        const { config, response } = error

        // If RateLimit-Reset header is present and the status code is 429 (Too Many Requests)
        if (response?.status === 429 && response?.headers.get('RateLimit-Reset')) {
            console.warn('rate-limit detected')
            const retryAfter = parseInt(response.headers.get('RateLimit-Reset'), 10); // in seconds

            // Delay the retry according to the RateLimit-Reset header value
            await new Promise(resolve => setTimeout(resolve, retryAfter * 1000)); // Convert seconds to milliseconds

            // Retry the original request
            return api(config);
        }

        if (config.meta?.showSnackbar !== false) {
            apiRequestCallback && apiRequestCallback(error.code === "ERR_NETWORK" ? 'Network Error. Please check your internet and try again' : error.response?.data?.message || `Unexpected error occured (Code ${error.response?.status})`, 'error')
        }

        if (response && response.status === 401) {
            sessionExpiryCallback && sessionExpiryCallback()
        }

        return Promise.reject(error);
    }
);

// Method to register the unauthorized callback
export const registerSessionExpiryCallback = (callback: TSessionExpiryCallback) => {
    sessionExpiryCallback = callback;
};

export const registerApiRequestCallback = (callback: TApiRequestCallback) => {
    apiRequestCallback = callback;
};

export default api;